import Icons from "../components/Icons";
import { STATUS } from "../constants/status";

// Devuelve el ícono según el peor estado registrado entre los sensores de la estación
export const getWorstStatus = (realtime) => {
    if (!realtime || realtime.length === 0) return STATUS.NO_DISPONIBLE;
    let worst = STATUS.BUENO;
    for (const sensor of realtime) {
        if (sensor.tableRow.statuscode > worst) {
            worst = sensor.tableRow.statuscode;
        }
    }
    return worst;
};

const STATUS_ICON = {
    [STATUS.BUENO]: Icons.bueno,
    [STATUS.REGULAR]: Icons.regular,
    [STATUS.ALERTA]: Icons.alerta,
    [STATUS.PRE_EMERGENCIA]: Icons.preemergencia,
    [STATUS.EMERGENCIA]: Icons.emergencia,
    [STATUS.NO_DISPONIBLE]: Icons.noDisponible,
};

export const iconSelector = (realtime, worstStatus) =>
    STATUS_ICON[worstStatus ?? getWorstStatus(realtime)] ?? Icons.noDisponible;

export default iconSelector;
